module.exports = __webpack_public_path__ + "media/images/fm_5-804493a5d507a5025cfaf72ef193a7c2.png";